import { Grid, Checkbox, FormControlLabel } from "@mui/material";
import HlxButton from 'component/commonComponents/button/button';
import Typography from 'component/commonComponents/Typography';
import React, { useMemo } from 'react';
import { StyledAddEditLanguage } from './addEditLanguage.style';
import TextBox from "component/commonComponents/Textbox/Textbox";

export interface IAddEditLanguageProps {
  language: {
    code: string;
    name: string;
    active: boolean;
  };
  onSubmit: (formData: any) => void;
  onCancel: () => void;
  handleOnBlur: (text: string) => void;
  locale: {
    add: string;
    edit: string;
    description: string;
    code: string;
    name: string;
    active: string;
    cancel: string;
    addLabel: string;
    editLabel: string;
  };
  languageErrMsg?: string;
};

const AddEditLanguage = (props: IAddEditLanguageProps) => {
  const { language, onSubmit, onCancel, locale, languageErrMsg, handleOnBlur } = props;
  const [formData, setFormData] = React.useState({
    code: language.code?.trim(),
    name: language.name?.trim(),
    active: language.active
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.name !== "active" ? e.target.value : e.target.checked
    });
  };

  const enableButton = useMemo(() => {
    return !!formData['code'] && !!formData['name']
  }, [formData]);

  return (
    <>
      <StyledAddEditLanguage>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography kind="h3" className="title">
              {language?.code ? locale.edit : locale.add}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography kind="h5" className="description">
              {locale.description}
            </Typography>
          </Grid>

          <Grid xs={6} item>
            <TextBox
              required
              label={locale.name}
              labelSize="small"
              boldLabel
              variant="outlined"
              name='name'
              value={formData.name}
              onChange={handleChange}
              fullWidth
              onBlur={() => setFormData({
                ...formData,
                name: formData.name.trim()
              })}
            />
          </Grid>

          <Grid xs={6} item>
            <TextBox
              required
              label={locale.code}
              labelSize="small"
              boldLabel
              variant="outlined"
              name='code'
              value={formData.code}
              onChange={handleChange}
              fullWidth
              errorMessage={languageErrMsg}
              error={!!languageErrMsg}
              disabled={!!language?.code}
              onBlur={() => {
                handleOnBlur(formData.code);
                setFormData({
                  ...formData,
                  code: formData.code.trim()
                });
              }}
            />
          </Grid>
          
          <Grid xs={12} item>
            <FormControlLabel
              control={<Checkbox checked={formData.active} onChange={handleChange} name="active" />}
              label={locale.active}
            />
          </Grid>

          <Grid item xs={12} container>
            <HlxButton
              disabled={!enableButton}
              label={language?.code ? locale.editLabel : locale.addLabel}
              onClick={() => onSubmit(formData)}
              style={{ marginRight: '10px' }}
              id="btn-language_drawer-confirm"
            />
            <HlxButton
              label={locale.cancel}
              variant="outlined"
              onClick={onCancel}
              id="btn-language_drawer-cancel"
            />
          </Grid>

        </Grid>
      </StyledAddEditLanguage>
    </>
  )
};

export const defaultProps = {
  language: {
    name: null,
    code: null,
    active: false,
  },
  onSubmit: (formData: any) => { },
  onCancel: () => { },
  handleOnBlur: (text: string) => { },
  locale: {
    add: 'Add New Language',
    edit: 'Edit Language',
    description: 'Language Details',
    code: 'Language Code',
    name: 'Language Name',
    active: 'Active',
    cancel: 'Cancel',
    addLabel: 'Add',
    editLabel: 'Save'
  },
  languageErrMsg: '',
};

AddEditLanguage.defaultProps = defaultProps;

export default AddEditLanguage;